"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapMode = void 0;
exports.SwapMode = {
    ExactInOrOut: 'ExactInOrOut',
    ExactIn: 'ExactIn',
    ExactOut: 'ExactOut',
};
